import { Modal } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import { useCallback, useEffect, useMemo } from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { ICustomerState, ITrackingAgreement } from '../../../../../model/CustomerModel';
import { useCustomerStore } from '../../../../../stores/CustomerStore';
import { DD_MM_YYYY_H_MM } from '../../../../../utils/app-common';
import { convertDateFromMillis } from '../../../../../utils/luxon';
import TableComponent from '../../../../CommonComponent/TableComponent';
import { useManifestContextHook } from './Context/useManifestContextHook';
type ITrackComponent = {
    isOpen: boolean,
    closeModal: () => void,
    data?: string
}
export const AgreementTrackingComponent = ({ isOpen, closeModal, data }: ITrackComponent) => {
    const { promiseInProgress: auditByWayBillProgress } = usePromiseTracker({ area: 'audit-by-way-bill-list-area' })
    const { waybillNo } = useManifestContextHook()
    const GetTrackingByWayBillAction = useCustomerStore((state: ICustomerState) => state?.GetTrackingByWayBillAction)
    const agreementTrackingList: ITrackingAgreement[] = useCustomerStore((state: ICustomerState) => state?.agreementTrackingList)

    const getTrackData = useCallback(() => {
        if (waybillNo || data) {
            useCustomerStore.setState({ agreementTrackingList: [] });
            trackPromise(GetTrackingByWayBillAction(waybillNo || data!), 'audit-by-way-bill-list-area');
        }
    }, [GetTrackingByWayBillAction, data, waybillNo])

    useEffect(() => {
        getTrackData();
    }, [getTrackData])

    const auditColumn: ColumnsType<ITrackingAgreement> = useMemo(() => [
        {
            title: 'waybill No',
            dataIndex: 'waybillNo',
            key: 'waybillNo',
            width: 120,
        },
        {
            title: 'base price',
            dataIndex: 'basePrice',
            key: 'basePrice',
            width: 120,
        },
        {
            title: 'Max unit',
            dataIndex: 'maxValUnitName',
            key: 'maxValUnitName',
            width: 120,
        },
        {
            title: 'Max unit value',
            dataIndex: 'maxUnitVal',
            key: 'maxUnitVal',
            width: 120,
        },
        {
            title: 'Sub unit',
            dataIndex: 'subUnitName',
            key: 'subUnitName',
            width: 120,
        },
        {
            title: 'Sub unit value',
            dataIndex: 'subUnitVal',
            key: 'subUnitVal',
            width: 120,
        },
        {
            title: 'Additional weight',
            dataIndex: 'additionalWeight',
            key: 'additionalWeight',
            width: 120,
        },
        {
            title: 'rto flat charge',
            dataIndex: 'rtoFlatCharge',
            key: 'rtoFlatCharge',
            width: 120,
        },
        {
            title: 'rto percentage',
            dataIndex: 'rtoPercentage',
            key: 'rtoPercentage',
            width: 120,
        },
        {
            title: 'partial delivery percentage',
            dataIndex: 'partialDelPercentage',
            key: 'partialDelPercentage',
            width: 120,
        },
        {
            title: 'partial flat delivery charge',
            dataIndex: 'partialFlatDelCharge',
            key: 'partialFlatDelCharge',
            width: 120,
        },
        // {
        //     title: 'COD Minimum Perecentage',
        //     dataIndex: 'codMinPercentage',
        //     key: 'codMinPercentage',
        //     width: 120,
        // },
        // {
        //     title: 'COD Minimum Charge',
        //     dataIndex: 'codMinCharge',
        //     key: 'codMinCharge',
        //     width: 120,
        // },
        {
            title: 'COD Service Charges',
            dataIndex: 'codMinCharge',
            key: 'codMinCharge',
            width: 120,
        },
        {
            title: 'insurance Percentage',
            dataIndex: 'insurancePercentage',
            key: 'insurancePercentage',
            width: 120,

        },
        {
            title: 'fsc',
            dataIndex: 'fsc',
            key: 'fsc',
            width: 120,

        },
        {
            title: 'agreement Bill Period',
            dataIndex: 'agreementBillPeriodName',
            key: 'agreementBillPeriodName',
            width: 120,

        },
        {
            title: 'Vat',
            dataIndex: 'vatName',
            key: 'vatName',
            width: 120,
        },
        {
            title: 'added by name',
            dataIndex: 'createdByName',
            key: 'createdByName',
            width: 120,
        },
        {
            title: 'added Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: 120,
            render: (_, record) => convertDateFromMillis(record?.createdDate, DD_MM_YYYY_H_MM)
        }
    ], [])

    const onResetClicked = useCallback(() => {
        getTrackData();
    }, [getTrackData])

    return (
        <>
            <Modal maskClosable={false} open={isOpen}
                onOk={closeModal} title={`Way Bill - ${waybillNo || data!}`} centered onCancel={closeModal} width={1400} cancelButtonProps={{
                    style: { display: 'none' }
                }}>
                <TableComponent
                    scroll={{ x: 0, y: 0 }}
                    columns={auditColumn}
                    onPaginationChange={() => { }}
                    isLoading={auditByWayBillProgress}
                    data={agreementTrackingList} id='id'
                    onRefreshHandle={onResetClicked} />
            </Modal>
        </>
    )
}
